import React from 'react';
import { remCss } from 'src/helpers';

const AiIcon = React.memo(({ width = 40 }) => (
  <svg
    fill='#000000'
    width={remCss(width)}
    height={remCss(width)}
    viewBox='0 0 256 256'
    id='Flat'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M200,56H56A23.99994,23.99994,0,0,0,32,80V192a23.99994,23.99994,0,0,0,24,24H200a23.99994,23.99994,0,0,0,24-24V80A23.99994,23.99994,0,0,0,200,56ZM164,184H92a20,20,0,0,1,0-40h72a20,20,0,0,1,0,40Z'
      opacity='0.2'
    />
    <path d='M200,48H136V16a8,8,0,0,0-16,0V48H56A32.03635,32.03635,0,0,0,24,80V192a32.03635,32.03635,0,0,0,32,32H200a32.03635,32.03635,0,0,0,32-32V80A32.03635,32.03635,0,0,0,200,48Zm16,144a16.01833,16.01833,0,0,1-16,16H56a16.01833,16.01833,0,0,1-16-16V80A16.01833,16.01833,0,0,1,56,64H200a16.01833,16.01833,0,0,1,16,16Zm-52-56H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-24,16v24H116V152ZM80,164a12.01343,12.01343,0,0,1,12-12h8v24H92A12.01343,12.01343,0,0,1,80,164Zm84,12h-8V152h8a12,12,0,0,1,0,24ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Z' />
  </svg>
));
AiIcon.displayName = 'AiIcon';

export default AiIcon;
